import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.token) {
    // User is authenticated, allow access
    return true;
  } else {
    // If no token is present, redirect to the login page
    router.navigateByUrl('/login');
    return false;
  }
};

export const EnterpriseAccess: CanActivateFn = () =>
  // route: ActivatedRouteSnapshot,
  // state: RouterStateSnapshot
  {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.token) {
      return true;
    } else {
      router.navigateByUrl('/login');
      return false;
    }
  };

export const HotelAccess: CanActivateFn = () =>
  // route: ActivatedRouteSnapshot,
  // state: RouterStateSnapshot
  {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.token) {
      return true;
    } else {
      router.navigateByUrl('/login');
      return false;
    }
  };
